export const content = {
    preTitle: 'Airhome butler',
    title: 'Designed For Remote Owners',
    text: 'Our mobile app will give you access to a smart and efficient (human) concierge.\n\nWe will organise repairs, maintanance, bill payment, cleaning and generate income with short term renting whenever you ask us to.',
    buttonCTA: 'See how buying works',
    screenshots: ['actions.png', 'chat.png', 'login.png', 'requests.png', 'unlock.png']
}